import { hPost, hGet } from '@mcfe/tools';

export const API = {
    VSS_PRINT_BEFORE_DATA: '/api/m/print/label/before/queryV2',
    // 查询打印标签信息
    VSS_PRINT_DATA: '/api/m/print/vss/prePurchase',
    // 查询预采计划列表
    MIGRATE_GRAY_V2: '/api/m/print/vss/migrate/grayV2',
    // 查询预采计划列表
    PLAN_DETAIL_LIST: '/api/scm/shepherd/pps/queryPrePurchasePlanDetailList',
    // 导出预采计划列表
    EXPORT_PLAN_DETAIL_LIST: '/api/scm/shepherd/pps/exportPrePurchasePlanDetailList',
};

export const exportPlanDetailList = (params, options) => hPost(API.EXPORT_PLAN_DETAIL_LIST, params, options);
export const getVssPrintBeforeData = (params, options) => hPost(API.VSS_PRINT_BEFORE_DATA, params, options);
export const getVssPrintData = (params, options) => hPost(API.VSS_PRINT_DATA, params, options);
export const getMigrateGrayV2 = (params, options) => hGet(API.MIGRATE_GRAY_V2, params, options);
